calendars-two_weeks
  calendars-date-ui(start="{opts.start}")
  calendars-daily(each="{daily_id in opts.items}" tag-scope="daily_{daily_id}")
  script(type="typescript").
    this.mixin('calendars.two_weeks');
